import { Redirect } from "expo-router";
import { ActivityIndicator } from "react-native";

import { CenteredScreen } from "~/components/ui";
import { useAuth } from "~/hooks/useAuth";
import { getPostAuthPath } from "~/utils/onboarding";

export default function Index() {
  const { session, user, loading } = useAuth();

  if (loading) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  if (!session?.user) {
    return <Redirect href="/login" />;
  }

  if (!user) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  return <Redirect href={getPostAuthPath(user) as never} />;
}
